module.exports = __webpack_public_path__ + "static/media/weChat.cf4820e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/home/weChat.jpg
// module id = 477
// module chunks = 0